import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getCustomerSpecialPricingByItem } from '../../../api/inventory/get-customer-special-pricing-by-item'

/* Initial state of the slice */
const initialState = {
  isFetchingItemSpecialPricingSummary: false,
  itemSpecialPricingSummary: [],
  fetchItemSpecialPricingSummaryError: null,
}
/* Handler for making service call to fetch Customer Group for a specific item */
export const fetchItemSpecialPricing = createAsyncThunk(
  'itemSpecialPricing/fetchItemSpecialPricing',
  async (args, { getState, rejectWithValue }) => {
    const state = getState()
    const request = {
      itemNumber: state.inventory.selectedInventoryItem.itemNumber.replaceAll('#', '%23'),
    }
    try {
      const response = await getCustomerSpecialPricingByItem(request)
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const itemSpecialPricingSlice = createSlice({
  name: 'itemSpecialPricing',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemSpecialPricing.pending, (state) => {
        state.isFetchingItemSpecialPricingSummary = true
        state.itemSpecialPricingSummary = []
        state.fetchItemSpecialPricingSummaryError = null
      })
      .addCase(fetchItemSpecialPricing.fulfilled, (state, action) => {
        state.isFetchingItemSpecialPricingSummary = false
        state.itemSpecialPricingSummary = action.payload
      })
      .addCase(fetchItemSpecialPricing.rejected, (state, action) => {
        state.isFetchingItemSpecialPricingSummary = false
        state.fetchItemSpecialPricingSummaryError = action.payload
      })
      /* When fetching inventory items is in progress, reset item codes */
      .addCase('inventory/fetchInventoryItems/pending', (state) => {
        state.itemSpecialPricingSummary = []
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export default itemSpecialPricingSlice.reducer
